import React, { useState, useEffect } from "react";
import NotFound404 from "./components/NotFound404";

const OfflineWrapper = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

if (!isOnline) {
  return <NotFound404 mode="offline" homeLink="/" />;
}

  return children;
};

export default OfflineWrapper;
